// Given an array of strings create a unique set array items
// e.g. ['a', 'b', 'a'] => ['a','b']
export default (arr: Array<string> | undefined) =>
  arr ? Array.from(new Set(arr)) : []
